import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserRolesComponent } from 'src/app/components/admin/admins/user-roles/user-roles.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { AngularFireFunctions } from '@angular/fire/functions';
import { RouteService } from 'src/app/shared/services/route.service';

export interface admin {
  nombre: string;
  email: string;
  privilegio: string;
  id: string;
}

@Component({
  selector: 'lista-admins',
  templateUrl: './lista-admins.component.html',
  styleUrls: ['./lista-admins.component.css']
})
export class ListaAdminsComponent implements OnInit {

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private router: Router,
    public dialog: MatDialog,
    public dialogService: DialogService,
    private functions: AngularFireFunctions,
    public routeService: RouteService,
  ) { }

  array: admin[] = [];

  ngOnInit(): void {
    this.cargarAdmins();
  }

  cargarAdmins() {
    this.afs.collection("admins").ref.get().then(response => {
      response.docs.forEach(doc=>{
        const data = doc.data();
        const admin: admin = {
          nombre: data['nombreCompleto'],
          email: data['email'],
          privilegio: data['privilegio'],
          id: data['uid'],
        }
        this.array = this.array.concat(admin)
      })
    })
  }

  openUserRoles(email) {
    let privilegio = '';
    if (email != ''){
      privilegio = this.array[this.array.findIndex(x => x.email == email)].privilegio;
    }    
    const dialogRef = this.dialog.open(UserRolesComponent, {
      data: {
        email: email,
        privilegio: privilegio, 
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result == true) {
        this.array = [];
        this.cargarAdmins();
      }
    });
  }

  eliminarAdmin(email) {
    this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
      if (res == true) {
        this.functions.httpsCallable("eliminarRole")({
          email: email,
        }).toPromise().then(() => {
          this.dialogService.dialogExito()
          this.array = [];
          this.cargarAdmins();
        })
      }
    })
  }
}
